'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.snapControlPointIfClose = exports.calculateControlPointPerpendicularMagnitude = exports.calculateControlPointParallelRatio = exports.shouldSnapToStraight = exports.isCurvedPastEndpoints = exports.isCloseToStraightLine = exports.getHalfwayPoint = undefined;

var _Vector = require('../../../common/maths/geometry/Vector');

var _Vector2 = _interopRequireDefault(_Vector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLOSE_TO_STRAIGHT_LINE_MAGNITUDE_THRESHOLD = 8; // Utils
var getHalfwayPoint = exports.getHalfwayPoint = function getHalfwayPoint(start, end) {
    var lineVector = _Vector2.default.lineVector(start, end);
    return lineVector.multiplyScalar(0.5).add(start);
};

var isCloseToStraightLine = exports.isCloseToStraightLine = function isCloseToStraightLine(controlPointPerpendicularMagnitude) {
    return Math.abs(controlPointPerpendicularMagnitude) < CLOSE_TO_STRAIGHT_LINE_MAGNITUDE_THRESHOLD;
};

var isCurvedPastEndpoints = exports.isCurvedPastEndpoints = function isCurvedPastEndpoints(controlPointParallelRatio) {
    return controlPointParallelRatio < 0 || controlPointParallelRatio > 1;
};

var shouldSnapToStraight = exports.shouldSnapToStraight = function shouldSnapToStraight(_ref) {
    var controlPointPerpendicularMagnitude = _ref.controlPointPerpendicularMagnitude,
        controlPointParallelRatio = _ref.controlPointParallelRatio;
    return isCloseToStraightLine(controlPointPerpendicularMagnitude) && !isCurvedPastEndpoints(controlPointParallelRatio);
};

var calculateControlPointParallelRatio = exports.calculateControlPointParallelRatio = function calculateControlPointParallelRatio(_ref2) {
    var controlPoint = _ref2.controlPoint,
        startEdgeOrigin = _ref2.startEdgeOrigin,
        endEdgeOrigin = _ref2.endEdgeOrigin;

    var lineVector = _Vector2.default.lineVector(startEdgeOrigin, endEdgeOrigin);
    // Move the controlPoint onto the start line's coordinate system
    var translatedControlPoint = _Vector2.default.fromObject(controlPoint).subtract(startEdgeOrigin);
    return lineVector.projectedRatio(translatedControlPoint);
};

var calculateControlPointPerpendicularMagnitude = exports.calculateControlPointPerpendicularMagnitude = function calculateControlPointPerpendicularMagnitude(_ref3) {
    var controlPoint = _ref3.controlPoint,
        startEdgeOrigin = _ref3.startEdgeOrigin,
        endEdgeOrigin = _ref3.endEdgeOrigin;

    var lineVector = _Vector2.default.lineVector(startEdgeOrigin, endEdgeOrigin);
    var perpindicularVector = lineVector.clone().perpendicular();

    // Move the controlPoint onto the start line's coordinate system
    var translatedControlPoint = _Vector2.default.fromObject(controlPoint).subtract(startEdgeOrigin);
    return perpindicularVector.projectedMagnitude(translatedControlPoint);
};

var snapControlPointIfClose = exports.snapControlPointIfClose = function snapControlPointIfClose(_ref4) {
    var controlPoint = _ref4.controlPoint,
        startEdgeOrigin = _ref4.startEdgeOrigin,
        endEdgeOrigin = _ref4.endEdgeOrigin;

    var controlPointPerpendicularMagnitude = calculateControlPointPerpendicularMagnitude({ controlPoint: controlPoint, startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin });
    var controlPointParallelRatio = calculateControlPointParallelRatio({ controlPoint: controlPoint, startEdgeOrigin: startEdgeOrigin, endEdgeOrigin: endEdgeOrigin });
    return shouldSnapToStraight({ controlPointPerpendicularMagnitude: controlPointPerpendicularMagnitude, controlPointParallelRatio: controlPointParallelRatio }) ? getHalfwayPoint(startEdgeOrigin, endEdgeOrigin) : controlPoint;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/lineControlPointUtil.js
// module id = 456
// module chunks = 0